export function productParams(item: Record<string, any>, vip: boolean) {
  const price = item.preferentialPrice ?? item.price
  return {
    purchase_type: vip ? 2 : 1,
    vip_type: vip ? (item.subscribeType === 0 ? 1 : 2) : undefined,
    purchase_id: vip ? item.subscribeConfigId : item.payConfigId,
    commodity_id: item.productId,
    price: item.price,
    amount: price == null ? undefined : Number(price) === 0 ? 'Free' : `${item.unit || '$'} ${price}`,
    given_coins: item.coinsBuy,
    given_free_coins: item.coinsBonus,
    vip_cycle: item.cycleStr ?? item.cycle,
    vip_coins: item.discountOnceCoins,
    vip_daily_coins: item.discountDailyCoins,
  }
}
